module.exports = __webpack_public_path__ + "img/bell.74e9fb99.svg";